export default __webpack_public_path__ + "static/media/DarkBlue0003.8f340528.png";